<template>
  <div>
    <v-autocomplete
      v-model="value.board"
      :items="creatBoardsDataMap"
      :loading="allBoardsPending"
      hide-no-data
      item-text="Description"
      item-value="id"
      :label="$t('tickets.view.board')"
      data-cy="board"
      :rules="requieredRule"
      dense
    ></v-autocomplete>
  </div>
</template>

<script>
import i18n from "../../../i18n";
import { mapGetters } from "vuex";
export default {
  props: ["value"],
  data: () => ({
    requieredRule: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
  }),
  computed: {
    ...mapGetters(["allBoards", "allBoardsPending"]),
    creatBoardsDataMap() {
      return this.allBoards.map((board) => {
        const Description = board.name;
        const id = board._id;
        return Object.assign({}, board, {
          Description,
          id,
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch("getAllBoards");
  },
  methods: {},
};
</script>
